<template>
    <base-layout title="基本信息" :hideFooter="true">
        <template slot="main">
            <div class="page-body">
                <p>数据更新说明：部分数据可能存在同步延迟。</p>
                <ul>
                    <li v-for="(info,index) in dataList" :key="index">
                        <dl>
                            <dt>
                                {{ info.title }}
                            </dt>
                            <dd v-for="(item,index_two) in info.list" :key="index_two">
                                <strong>{{ item.name }}</strong>
                                <p @click="toPage(item.href)" :class="item.href !== undefined?'a':''">{{
                                        item.content
                                    }}</p>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </template>
    </base-layout>

</template>

<script>
// 页面布局组件
import baseLayout from "@comm/view/layout/baseLayout";
// 用户信息存储
import userStore from "@comm/store/user/userInfo.store";

function getDataList(userInfo) {
    return [
        {
            title: '手机号',
            list: [
                {
                    name: '使用目的',
                    content: '完成账号注册'
                },
                {
                    name: '使用场景',
                    content: '用户基本信息'
                },
                {
                    name: '收集情况',
                    content: userInfo.anonymousFlag != 1 && userInfo.cellPhone ? '已收集' : '未收集'
                },
                {
                    name: '信息内容',
                    content: userInfo.anonymousFlag != 1 && userInfo.cellPhone ? String(userInfo.cellPhone).replace(/^(.*)\d{4}(\d{4})$/, (str, $1, $2) => $1 + '****' + $2) : '-'
                }
            ]
        },
        {
            title: '生日',
            list: [
                {
                    name: '使用目的',
                    content: '完成账号注册'
                },
                {
                    name: '使用场景',
                    content: '完善个人资料'
                },
                {
                    name: '收集情况',
                    content: userInfo.birthday ? '已收集' : '未收集'
                },
                {
                    name: '信息内容',
                    content: '个人资料',
                    href: '/my/personalInfo'
                }
            ]
        },
        {
            title: '性别',
            list: [
                {
                    name: '使用目的',
                    content: '资料信息补充'
                },
                {
                    name: '使用场景',
                    content: '完善个人资料'
                },
                {
                    name: '收集情况',
                    content: userInfo.sex ? '已收集' : '未收集'
                },
                {
                    name: '信息内容',
                    content: '个人资料',
                    href: '/my/personalInfo'
                }
            ]
        },
        {
            title: '头像',
            list: [
                {
                    name: '使用目的',
                    content: '资料信息补充'
                },
                {
                    name: '使用场景',
                    content: '完善个人资料'
                },
                {
                    name: '收集情况',
                    content: userInfo.headerUrl ? '已收集' : '未收集'
                },
                {
                    name: '信息内容',
                    content: '个人资料',
                    href: '/my/personalInfo'
                }
            ]
        },
    ]
}

export default {
    name: 'systemStatuteCollectionBaseInfo',
    components: {
        // 页面布局组件
        baseLayout,
    },
    created() {
        // 更新用户信息
        userStore.dispatch('updateUserDetail', { pageFlag: 'collection', payload: "cancellation" }).then(() => {
            this.dataList = getDataList(userStore.getters.userInfo);
        }, () => {

        });
    },
    data() {
        return {
            dataList: getDataList(userStore.getters.userInfo)
        }
    },
    methods: {
        // 页面跳转
        toPage(href) {
            if (href) this.$router.push(href)
        }
    }
}
</script>


<style lang="scss" scoped>
.page-body {
    padding: 10px;
    height: 100%;
    overflow-y: scroll;
    position: relative;
    box-sizing: border-box;

    > p {
        color: gray;
        font-size: 12px;
        padding-bottom: 5px;
    }

    ul {
        li {
            padding-bottom: 10px;
        }
    }

    dl {
        padding: 10px;
        border-radius: 5px;
        background-color: #f7f7f7;
    }

    dt {
        font-size: 14px;
        font-weight: bold;
        padding-bottom: 5px;
    }

    dd {
        display: flex;
        position: relative;
        align-content: center;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 25px;

        strong {
            min-width: 60px;
            display: block;
            font-weight: normal;
        }

        p {
            flex: 1;
            display: flex;
            color: #999CA0;

            &.a {
                color: #2c4adc;
                text-decoration: underline;
            }
        }
    }
}
</style>